import { Roles } from "./session";

// SECURITY: Mock accounts for development ONLY
// These accounts must NEVER be available in production builds
// They contain known credentials that would be a security vulnerability
const DEV_MOCK_ACCOUNTS = [
  {
    email: "admin@test.com",
    password: "password",
    name: "Break Admin",
    roles: [Roles.ADMIN, Roles.TALENT_MANAGER],
    avatar: null
  },
  {
    email: "seller@test.com",
    password: "password",
    name: "Seller Summit",
    roles: [Roles.SELLER],
    avatar: null
  },
  {
    email: "buyer@test.com",
    password: "password",
    name: "Buyer Beta",
    roles: [Roles.BUYER],
    avatar: null
  },
  {
    email: "buyerseller@test.com",
    password: "password",
    name: "Hybrid Hero",
    roles: [Roles.BUYER_SELLER],
    avatar: null
  },
  {
    email: "agent@test.com",
    password: "password",
    name: "Agent Apex",
    roles: [Roles.AGENT],
    avatar: null
  },
  {
    email: "valuation@test.com",
    password: "password",
    name: "Valuation Pulse",
    roles: [Roles.VALUATION],
    avatar: null
  }
];

// Only export mock accounts in development mode
// Production builds will have an empty array
export const MOCK_ACCOUNTS = import.meta.env.MODE === 'development' ? DEV_MOCK_ACCOUNTS : [];
